// extracted by mini-css-extract-plugin
export default {"RoundButtonArrowMain":"RoundButtonArrowMain_RoundButtonArrowMain__MPKe3","filled":"RoundButtonArrowMain_filled__XBIZL","main":"RoundButtonArrowMain_main__uWfFb"};